<template>
  <nav class="sc-tabs mb-3">
    <li
      class="sc-tab"
      v-for="(tab, index) in tabs"
      :key="index"
      v-show="tab.isShow"
      :class="{ active: currentTab.name === tab.name }"
      @click="changeTab(tab)"
    >
      {{ tab.name }}
    </li>
  </nav>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    currentTab() {
      return this.value || this.tabs[0];
    },
    tabs() {
      const tabs = [
        { name: "เนื้อหา", isShow: true },
        { name: "รายละเอียดกิจกรรม", isShow: true }
      ];

      return tabs;
    }
  },
  methods: {
    changeTab(to) {
      this.$emit("input", to);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/features/ruejai-club/modules/voucher-package/components/ContentTabs.vue